import { render, staticRenderFns } from "./appAdminNested.vue?vue&type=template&id=30dd2bf8"
import script from "./appAdminNested.vue?vue&type=script&lang=js"
export * from "./appAdminNested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports